<div *ngIf="!formJson">Loading...</div>
<form [formGroup]="ucmFormGroup">
  <form-renderer
    *ngIf="isFormRendered"
    [formJson]="formJson"
    [showDebugConsoleMessages]="showDebugConsoleMessages"
    [apiEndpoint]="apiEndpoint"
    [apiKey]="apiKey"
    [elementDefaults]="elementDefaults"
    (formEvents)="onFormEvent($event)"
  >
  </form-renderer>
</form>
